module.exports = __webpack_public_path__ + "img/h6.096ca6e0.png";